export const integrationSlugToDocs: {
  destination: Record<string, string>;
  source?: Record<string, string>;
} = {
  // Maps the integration slug from sanity to the slug used for the docs url
  destination: {
    "webhook-v2": "http-request",
    "pardot-sandbox": "pardot",
    "salesforce-sandbox": "salesforce",
    "google-sheets-sa": "google-sheets",
    "google-bigquery-destination": "google-bigquery",
  },
};
